import React, { Component } from 'react';
import { batch, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountFreebet.js';
import Loader from 'Loader.js';
import Datepicker from 'Datepicker.js';
import Pagination from 'Pagination.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _get from 'lodash/get';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate } from 'datesHelper.js';
import {
  changeDateByType,
  fetchFreebetsByFilter,
  setCurrentPage,
  fetchAllFreebets,
  changeActiveTab,
  resetToInitialState,
} from 'accountFreebetActions.js';
import CalendarIcon from 'calendar_icon.png';
import { proccessFrontError } from 'errorActions.js';

class AccountFreebet extends Component {
  constructor(props) {
    super(props);
    this.dateStartRef = React.createRef();
    this.dateEndRef = React.createRef();
  }

  componentDidMount = async () => {
    const accountBonusSelector = document.querySelector('.account-freebets');
    if (accountBonusSelector) {
      accountBonusSelector.addEventListener('click', this.handleOutsideClick, false);
    }

    const { fetchFreebetsByFilter, processFrontError } = this.props;

    try {
      await fetchFreebetsByFilter();
    } catch (error) {
      processFrontError(error, 'AccountFreebet.componentDidMount');
    }
  };

  componentWillUnmount = () => {
    const accountBonusSelector = document.querySelector('.account-freebets');
    if (accountBonusSelector) {
      accountBonusSelector.removeEventListener('click', this.handleOutsideClick, false);
    }

    const { resetToInitialState } = this.props;
    resetToInitialState();
  };

  handleOutsideClick = (e) => {
    const datePickerPopperSelector = document.querySelector('.react-datepicker-popper');
    if (datePickerPopperSelector && !datePickerPopperSelector.contains(e.target)) {
      this.dateEndRef?.current?.setOpen(false);
      this.dateStartRef?.current?.setOpen(false);
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchFreebetsByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchFreebetsByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchFreebetsByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchFreebetsByFilter();
    });
  };

  goPage = (currentPage, activeTab) => {
    const { fetchFreebetsByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage, activeTab);
        fetchFreebetsByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountFreebet.goPage');
    }
  };

  render() {
    const { isPending, activeTab, startDate, endDate, freebets, limit, currencyCode } = this.props;
    const {
      data: activeFreebetsData,
      currentPage: activeFreebetsCurrentPage,
      isNextPageAvailable: activeFreebetsIsNextPageAvailable,
    } = freebets.active;
    const {
      data: historyFreebetsData,
      currentPage: historyFreebetsCurrentPage,
      isNextPageAvailable: historyFreebetsIsNextPageAvailable,
    } = freebets.history;

    return (
      <S.AccountFreebet className="account-freebets">
        <S.AccountFreebetTitle>{translation('account_freebet_title')}</S.AccountFreebetTitle>

        <S.FreebetFilters className="freebet-filters">
          <S.FreebetFiltersBtns>
            <S.FilterBtn
              isActive={activeTab == 'active'}
              onClick={this.onChangeFilter.bind(this, 'active')}
            >
              {translation('account_bonus_active')}
            </S.FilterBtn>
            <S.FilterBtn
              isActive={activeTab == 'history'}
              onClick={this.onChangeFilter.bind(this, 'history')}
            >
              {translation('account_freebets_historyFreebets')}
            </S.FilterBtn>
          </S.FreebetFiltersBtns>

          {activeTab == 'history' && (
            <S.FiltersDates className="bet-history-filters-dates">
              <S.DateLabel
                dangerouslySetInnerHTML={{ __html: translation('account_betHistory_dateRange') }}
              />

              <S.DateWrapper className="date-wrapper">
                <S.DateIconWrapper>
                  <S.DateIcon src={CalendarIcon} />
                </S.DateIconWrapper>

                <Datepicker
                  disabled={activeTab == 'active'}
                  ref={this.dateStartRef}
                  selected={startDate}
                  selectsStart
                  dateFormat="dd-MM-yyyy"
                  cb={this.handleChangeStart}
                  popperPlacement="bottom-end"
                />
              </S.DateWrapper>

              <S.DateWrapper className="date-wrapper">
                <S.DateIconWrapper>
                  <S.DateIcon src={CalendarIcon} />
                </S.DateIconWrapper>

                <Datepicker
                  disabled={activeTab == 'active'}
                  ref={this.dateEndRef}
                  minDate={startDate}
                  selected={endDate}
                  selectsEnd
                  dateFormat="dd-MM-yyyy"
                  cb={this.handleChangeEnd}
                  popperPlacement="bottom-end"
                  startDate={startDate}
                  endDate={endDate}
                />
              </S.DateWrapper>
            </S.FiltersDates>
          )}
        </S.FreebetFilters>

        <S.FreebetListWrapper>
          {isPending ? (
            <Loader />
          ) : (
            <>
              {activeTab == 'active' && (
                <>
                  {activeFreebetsData.length > 0 ? (
                    <>
                      <S.FreebetList>
                        {activeFreebetsData.map((freebet) => {
                          let { validTo, nameKey, offerId, freebetStake, offerPlayerInfo } =
                            freebet;
                          offerPlayerInfo = offerPlayerInfo ?? {};
                          const { imageUrl = null, rulesPageUrl = null } = offerPlayerInfo;
                          const freebetItem = (
                            <S.FreebetItem key={offerId}>
                              <S.FreebetHeader>
                                <S.FreebetTitle data-translation={nameKey}>
                                  {translation(nameKey)}
                                </S.FreebetTitle>
                              </S.FreebetHeader>

                              <S.FreebetImageWrapper ratio={2}>
                                {imageUrl && <S.FreebetImage src={imageUrl} />}
                              </S.FreebetImageWrapper>

                              <S.FreebetBody>
                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_offerId')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>{offerId}</S.FreebetBoxValue>
                                </S.FreebetBox>

                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_freebetAmount')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>
                                    {formatMoney(freebetStake)}&nbsp;{currencyCode}
                                  </S.FreebetBoxValue>
                                </S.FreebetBox>

                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_freebetExpirationDate')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>
                                    {formatDate(validTo, 'yyyy.MM.dd HH:mm')}
                                  </S.FreebetBoxValue>
                                </S.FreebetBox>
                              </S.FreebetBody>

                              <S.FreebetFooter>
                                <S.FreebetRegulationLink
                                  href={rulesPageUrl ? rulesPageUrl : '/'}
                                  target="_blank"
                                >
                                  {translation('account_bonus_regulationLink')}
                                </S.FreebetRegulationLink>
                              </S.FreebetFooter>
                            </S.FreebetItem>
                          );
                          return freebetItem;
                        })}
                      </S.FreebetList>
                      <Pagination
                        {...{
                          currentPage: activeFreebetsCurrentPage,
                          limit,
                          data: activeFreebetsData,
                          isNextPageAvailable: activeFreebetsIsNextPageAvailable,
                          callback: (currentPage) => this.goPage(currentPage, 'active'),
                        }}
                      />
                    </>
                  ) : (
                    <S.NoResult>{translation('account_freebets_noActiveFreebets')}</S.NoResult>
                  )}
                </>
              )}

              {activeTab == 'history' && (
                <>
                  {_size(historyFreebetsData) ? (
                    <>
                      <S.FreebetList>
                        {_map(historyFreebetsData, (freebet) => {
                          let {
                            validTo,
                            nameKey,
                            betSlipId,
                            freebetStake,
                            offerId,
                            offerPlayerInfo,
                            offerName,
                          } = freebet;
                          offerPlayerInfo = offerPlayerInfo ?? {};
                          const { imageUrl = null, rulesPageUrl = null } = offerPlayerInfo;
                          const freebetItem = (
                            <S.FreebetItem key={offerId}>
                              <S.FreebetHeader>
                                <S.FreebetTitle data-translation={nameKey}>
                                  {translation(nameKey)}
                                </S.FreebetTitle>
                              </S.FreebetHeader>

                              <S.FreebetImageWrapper ratio={2}>
                                {imageUrl && <S.FreebetImage src={imageUrl} />}
                              </S.FreebetImageWrapper>

                              <S.FreebetBody>
                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_offerId')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>{offerId}</S.FreebetBoxValue>
                                </S.FreebetBox>

                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_freebetAmount')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>
                                    {formatMoney(freebetStake)}&nbsp;{currencyCode}
                                  </S.FreebetBoxValue>
                                </S.FreebetBox>

                                <S.FreebetBox>
                                  <S.FreebetBoxTitle>
                                    {translation('account_freebets_freebetExpirationDate')}
                                  </S.FreebetBoxTitle>
                                  <S.FreebetBoxValue>
                                    {formatDate(validTo, 'yyyy.MM.dd HH:mm')}
                                  </S.FreebetBoxValue>
                                </S.FreebetBox>
                              </S.FreebetBody>

                              <S.FreebetFooter>
                                <S.FreebetRegulationLink
                                  href={rulesPageUrl ? rulesPageUrl : '/'}
                                  target="_blank"
                                >
                                  {translation('account_bonus_regulationLink')}
                                </S.FreebetRegulationLink>
                              </S.FreebetFooter>
                            </S.FreebetItem>
                          );
                          return freebetItem;
                        })}
                      </S.FreebetList>

                      <Pagination
                        {...{
                          currentPage: historyFreebetsCurrentPage,
                          limit,
                          data: historyFreebetsData,
                          isNextPageAvailable: historyFreebetsIsNextPageAvailable,
                          callback: (currentPage) => this.goPage(currentPage, 'history'),
                        }}
                      />
                    </>
                  ) : (
                    <S.NoResult>{translation('account_freebets_noHistoryFreebets')}</S.NoResult>
                  )}
                </>
              )}
            </>
          )}
        </S.FreebetListWrapper>
      </S.AccountFreebet>
    );
  }
}

const mapStateToProps = (
  {
    AccountFreebet: { isPending, error, startDate, endDate, freebets, limit, activeTab },
    Auth: {
      user: { currencyCode },
    },
  },
  props
) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    freebets,
    limit,
    currencyCode,
    activeTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchFreebetsByFilter: bindActionCreators(fetchFreebetsByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchAllFreebets: bindActionCreators(fetchAllFreebets, dispatch),
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    resetToInitialState: bindActionCreators(resetToInitialState, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountFreebet);
